(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('SupportController', SupportController);

    SupportController.$inject = ['$scope', '$uibModalInstance'];

    function SupportController($scope, $uibModalInstance) {
        var vm = this;

        vm.close = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();